import { apiService, Endpoints } from "api";

export const removeBusinessEntity = async (id: number) =>
  await apiService.delete(Endpoints.BusinessEntities.Delete.ById(id));
